const themes = [
  'primary',
  'positive',
  'negative',
  'support',
  'alert',
  'complementary',
  'disabled',
  'white',
  'canceled',
  'positive-2',
]

export const theme = {
  props: {
    /**
     * The type of theme
     */
    theme: {
      type: [ String ],
      validator: theme => {
        return themes.includes(theme)
      }
    }
  }
}
